import script from "./CalendarCreateJa.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarCreateJa.vue?vue&type=script&setup=true&lang=js"

import "./CalendarCreateJa.vue?vue&type=style&index=0&id=2fb2cf7f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fb2cf7f"]])

export default __exports__